export const ReservationRoutes = {
  LIST: "/reservations",
  DETAIL: "/reservations/:id",
} as const;
